module.exports = __webpack_public_path__ + "media/images/banners/banner-1-6a5f03801dd9d7989bd66361f0f43413.png";